import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { Typography } from '@mui/material'
import { Button } from 'components'
import { ElementType, PropsWithChildren } from 'react'
import { Content, StyledDrawer } from './Modal.ui'

interface CustomModalProps {
  isDrawer?: boolean
  onClose?(): void
  // TODO: revise parameters typeing
  onConfirm?(args?: any): void
  onConfirmButtonText?: string
  confirmButtonColor?: 'warning' | 'error' | 'info' | 'success'
  confirmButtonDisabled?: boolean
  isOpen: boolean
  isLoading?: boolean
  title?: string
  customHeader?: ElementType
  customFooter?: ElementType
  okButtonType?: 'submit'
  hideConfirmButton?: boolean
}

export default function CustomModal({
  isDrawer,
  isOpen,
  isLoading,
  children,
  title,
  onClose,
  onConfirm,
  onConfirmButtonText,
  confirmButtonColor,
  confirmButtonDisabled,
  customHeader: CustomHeader,
  customFooter: CustomFooter,
  okButtonType,
  hideConfirmButton,
}: PropsWithChildren<CustomModalProps>) {
  const container =
    window !== undefined ? () => window.document.body : undefined

  const handleDefaultConfirm = () => {
    onConfirm && onConfirm()
  }

  if (isDrawer) {
    return (
      <StyledDrawer
        container={container}
        open={isOpen}
        onClose={onClose}
        variant="permanent"
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          style: {
            width: 230,
          },
        }}
      >
        {children}
      </StyledDrawer>
    )
  }

  const DefaultHeader = ({ children }) => (
    <Box
      sx={{
        boxShadow:
          '0px 4px 6px rgba(0, 0, 0, 0.04), 0px 1px 3px rgba(238, 237, 237, 0.04)',
      }}
      width="100%"
      height="58px"
      display="flex"
      alignItems="center"
      padding="0px 30px"
    >
      {children}
    </Box>
  )

  const DefaultFooter = (
    <Box
      width="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      padding="16px 24px"
    >
      <Button variantType="secondary" onClick={onClose}>
        Cancel
      </Button>
      {!hideConfirmButton && (
        <Button
          onClick={handleDefaultConfirm}
          form="hook-form"
          type={okButtonType}
          disabled={isLoading || confirmButtonDisabled}
          color={confirmButtonColor}
        >
          {onConfirmButtonText || 'Process'}
        </Button>
      )}
    </Box>
  )

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      // TODO: color from theme
      sx={{ '& .MuiBackdrop-root': { backgroundColor: '#2A343D6B' } }}
    >
      <Content gap={2}>
        {CustomHeader ? (
          <CustomHeader />
        ) : (
          <DefaultHeader>
            <Typography component={'h2'} fontSize="22px" color="#4F4848">
              {title}
            </Typography>
          </DefaultHeader>
        )}
        {children}
        {CustomFooter ? <CustomFooter /> : DefaultFooter}
      </Content>
    </Modal>
  )
}
